angular.module('dealerware.web.data').factory('DealerwareCreditCardModel', function ($http,Model,$q) {
        var model = new Model({
            baseEndpoint: "/locations/:location_id/customers/:customer_id/credit_card",
            customActions:  {
                get: {
                    method: 'GET',
                    ignoreDefaultRootNodeResponse: true,
                    ignoreAssociations: true
                },
                clientToken: {
                    method: 'GET',
                    endpoint: '/braintree_customers/client_token',
                    ignoreDefaultRootNodeResponse : true,
                    ignoreAssociations            : true
                },
                paymentProcessor: {
                    method: 'GET',
                    endpoint: '/admin/dealerships/:location_id/payment_processors/primary',
                    ignoreDefaultRootNodeResponse : true,
                    ignoreAssociations            : true,
                    headers: { 'Api-Version': '4', 'Accept': 'application/json' },
                },
                createWithNonce: {
                    method: 'POST',
                    ignoreDefaultRootNodeRequest  : true,
                    ignoreDefaultRootNodeResponse : true,
                    isCollection                  : true,
                    ignoreAssociations            : true,
                    ignoreDefaultParams           : true
                }
            },
            requestTransforms: {
                all: function(data, args) {
                    // Remove the card number from the hash if it's obfuscated
                    if (data.number && data.number.startsWith('*')) {
                        delete data.number;
                    }


                    // Split expiration date into component fields
                    if (data.expiration) {
                        var split = data.expiration.split('/');
                        data.expiration_month = split[0];
                        data.expiration_year  = split[1];
                    }

                    // Strip out fields we can't set
                    var deleteFields = ['user_profile_id', 'token', 'last_four', 'expiration'];
                    for (var i=0; i<deleteFields.length; i++) {
                        delete data[deleteFields[i]];
                    }

                },
                canRent: function(data,args) {
                    delete data.can_rent;
                },
                create: function(args, data) {
                    this.all(data, args);
                },
                update: function(args, data) {
                    this.all(data, args);
                },
                createWithNonce: function(args,data) {
                    this.all(data,args);
                }
            },
            responseTransforms: {
                index: transformResponse,
                get: transformResponse
            }
        });

        function transformResponse(args, data) {
            if (data.expiration_month && data.expiration_year) {
                data.expiration = ('00' + data.expiration_month).slice(-2) + '/' + data.expiration_year;
            }
            if (data.last_four) {
                data.number = '**** **** **** ' + data.last_four;
            }
        }

        jQuery.extend(model.prototype,{
            isComplete: function() {
                var isComplete = false;
                if ( this.data && isObject(this.data) ) {
                    if ( this.data.hasOwnProperty('card_type') && this.data.card_type ) {
                        if ( this.data.hasOwnProperty('last_four') && this.data.last_four ) {
                            isComplete = true;
                        }
                    }
                }
                return isComplete;
            },
            toSummaryString: function() {
                var sum = '';
                if (this.data && isObject(this.data)) {
                    if (this.data.hasOwnProperty('card_type') && this.data.card_type && this.data.hasOwnProperty('last_four') && this.data.last_four ) {
                        sum = this.data.card_type + " " + this.data.last_four;
                    }
                }
                return sum;
            },
            isRequired: function() {
                return !this.isComplete();
            },
            getId: function() {
                return ( this.data && isObject(this.data) && this.data.hasOwnProperty('id')) ? this.data.id : undefined;
            },
            getPaymentProcessingErrors: function(successCallback,errorCallback) {
                var id = this.getId();
                errorCallback = (errorCallback && isFunction(errorCallback) ) ? errorCallback : noop;
                if ( !id ) {
                    errorCallback({message: "undefined id"});
                }
                else {
                    this.paymentProcessingErrors = resource.getProcessingErrors({
                        params: {id: id},
                        success: successCallback,
                        error: errorCallback
                    });
                }
            },
            getClientToken: function() {
                var deferred = $q.defer();
                this.$clientToken({
                    promise: true}).then(
                        function(returnValue,response) {
                            deferred.resolve(returnValue,response);
                        },
                        function(response) {
                            deferred.reject(response);
                        }
                    );
                return deferred.promise;
            },
            getNewBlankCreditCard: function() {
                return new this.constructor({
                    number            : undefined,
                    cardholder_name   : undefined,
                    cvv               : undefined,
                    postal_code       : undefined,
                    expiration_date   : undefined,
                    expiration_month  : undefined,
                    expiration_year   : undefined
                });
            },
            getActiveCreditCard: function(rejectIfNotFound) {
                var deferred = $q.defer();
                var _self = this;

                this.$get({
                    successCallback: function(returnValue,response) {
                        var _creditCard;
                        if (returnValue && isObject(returnValue) && returnValue.hasOwnProperty('data') && angular.isArray(returnValue.data) && returnValue.data.length > 0) {
                            var _ccData = returnValue.data[returnValue.data.length - 1];
                            _creditCard = new _self.constructor(_ccData);
                            deferred.resolve(_creditCard,response);
                        }
                        else {
                            deferred.reject({data: {message: 'An error occured parsing credit card.'}});
                        }
                    },
                    errorCallback: function(response){
                        deferred.reject(response);
                    }
                });
                return deferred.promise;
            },
            ccInfoChange: function() {
                if (!this.isUnchanged()){
                    this.data.verified = false;
                }
            },
            cardDataChanged: function() {
                var changed = false;
                var self = this;
                var cardFields = [
                    'cardholder_name',
                    'number',
                    'postal_code',
                    'country_code',
                    'expiration'
                ];
                $.each(cardFields,function(idx,fname){
                    if (self.data[fname] !== self.master[fname]) {
                        changed = true;
                        return false;
                    }
                });
                return changed;
            },
            cardNumberChanged: function() {
                var changed = false;
                var self = this;
                var cardFields = [
                    'number'
                ];
                $.each(cardFields,function(idx,fname){
                    if (self.data[fname] !== self.master[fname]) {
                    changed = true;
                    return false;
                    }
                });
                return changed;
            },
            addressChanged: function() {
                var changed = false;
                var self = this;
                var cardFields = [
                    'postal_code'
                ];
                $.each(cardFields,function(idx,fname){
                    if (self.data[fname] !== self.master[fname]) {
                        changed = true;
                        return false;
                    }
                });
                return changed;
            },
            cardOtherAttributesChanged: function() {
                var changed = false;
                var self = this;
                var cardFields = [
                    'verified',
                    'allow_debit'
                ];
                $.each(cardFields,function(idx,fname){
                    if (self.data[fname] !== self.master[fname]) {
                        changed = true;
                        return false;
                    }
                });
                return changed;
            },
            saveCreditCard: function(nonce) {
                var deferred = $q.defer(),
                    self = this,
                    mode = self.data.id !== undefined ? 'update' : 'create',
                    newCC = new model({
                        nonce: nonce
                    });

                newCC.$createWithNonce({
                    params: {
                        location_id: self.data.location_id,
                        customer_id: self.data.customer_id,
                        cardholder_name: self.data.cardholder_name,
                        verified: false,
                        allow_debit: self.data.allow_debit
                    },
                    successCallback: function(returnValue, response) {
                        deferred.resolve(returnValue, response);
                    },
                    errorCallback: function(response) {
                        deferred.reject(response);
                    }
                });

                return deferred.promise;
            },
            getCardData: function() {
                var _self   = this;
                var _ccData = {
                    cardholderName  : _self.data.cardholder_name
                };

                if (_self.data.number && !_self.data.number.startsWith('*')) {
                    _ccData.number = _self.data.number;
                }

                if (_self.data.expiration) {
                    _ccData.expirationDate = _self.data.expiration;
                }
                else if (_self.data.expiration_month && _self.data.expiration_year) {
                    _ccData.expirationMonth = _self.data.expiration_month;
                    _ccData.expirationYear = _self.data.expiration_year;
                }
                return _ccData;
                },
            getCreditCardSummary: function() {
                return "Personal ..." + this.data.last_four;
            },
            getLink: function(type) {
                var links = this.data.links;

                for (var i = 0; i < this.data.links.length; i++) {
                    if (links[i].type === type) {
                        return links[i];
                    }
                }
            }
        });
        return model;
    })
    .config(function($provide) {
        $provide.decorator('CreditCardModel', function($delegate,$injector) {
            return $injector.get("DealerwareCreditCardModel");
        });
    });
